import * as React from "react";

function SvgExclamationMark(props) {
  return <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}><g transform="translate(1 1)" fill="none" fillRule="evenodd"><circle stroke="#FFF" fill="#FF4B49" cx={5} cy={5} r={5.5} /><path d="M5.358 6.208l.209-4.241H4.442l.208 4.241h.708zM5 7.917a.677.677 0 00.467-.175.635.635 0 00.183-.459.615.615 0 00-.183-.45A.662.662 0 005 6.658a.61.61 0 00-.45.175.564.564 0 00-.192.45c0 .184.059.334.192.45a.615.615 0 00.45.184z" fill="#FFF" fillRule="nonzero" /></g></svg>;
}

export default SvgExclamationMark;